export const CREATE_USER = 'CREATE_USER';
export const READ_USERS = 'READ_USERS';
export const UPDATE_USER = 'UPDATE_USER';
export const DESTROY_USER = 'DESTROY_USER';
export const SET_LOADING = 'SET_LOADING';
